<template>
  <v-dialog
    v-model="value"
    class="user_modal_dialog"
    max-width="952"
    persistent
    @click:outside="close"
  >
    <v-card>
      <v-card-title>
        <span class="headline title_modal_user">{{ formTitle }}</span>
        <v-icon class="info_modal_close" @click="close">mdi-close</v-icon>
      </v-card-title>
      <validation-observer
        ref="contractFormObs"
        v-slot="{ handleSubmit }"
        tag="div"
      >
        <form @submit.prevent="handleSubmit(save)">
          <v-card-text class="main_modal px-6">
            <div class="row">
              <div v-if="formState === 'create'" class="col-sm-6 col-md-6 py-0">
                <div class="row no-gutters">
                  <div class="medium_15_01456A pt-lg-5 col-lg-5">
                    {{ $t("contractNumber") }}
                  </div>
                  <custom-input-text
                    v-model="editedItem.code"
                    :name="$t('contractNumber')"
                    :placeholder="$t('contractNumber')"
                    class="col-lg-7 user_input"
                    rules="required"
                  >
                  </custom-input-text>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 py-0">
                <div class="row no-gutters py-1">
                  <div class="col-lg-5 pt-lg-2 pt-0 medium_15_01456A">
                    {{ $t("typeProduct") }}
                  </div>
                  <vue-select
                    ref="productTypeSelect"
                    infinite
                    v-model="productFilter.type_id"
                    :get-item-promise="
                      ({ text, page }) =>
                        $store.dispatch('getProductTypes', {
                          name: text,
                          page,
                          limit: 15,
                        })
                    "
                    :items="productTypes"
                    :name="$t('categoryProduct')"
                    class="col-lg-7 product-select-in-modal"
                    clearable
                    @item-resolved="setProductType"
                    @next-page-resolved="
                      (data) => setProductType([...productTypes, ...data])
                    "
                    @input="handleProductTypeChange"
                  ></vue-select>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 py-0">
                <div class="row no-gutters py-1">
                  <div class="col-lg-5 pt-lg-3 pt-0 medium_15_01456A">
                    {{ $t("supplier") }}
                  </div>
                  <div class="col-lg-7 pt-0 d-flex align-center">
                    <vue-select
                      infinite
                      v-model="editedItem.supplierId"
                      @item-resolved="setSupplier"
                      @next-page-resolved="
                        (data) => setSupplier([...suppliers, ...data])
                      "
                      :get-item-promise="
                        ({ text, page }) =>
                          $store.dispatch('getSuppliers', { name: text, page })
                      "
                      :disabled="formState === 'add' || formState === 'edit'"
                      :items="suppliers"
                      :name="$t('supplier')"
                      :placeholder="$t('supplier')"
                      class="product-select-in-modal flex-grow-1"
                      rules="required"
                    ></vue-select>
                    <div
                      class="modal_plus_icon_ft mt-3"
                      @click="supplierDialog = true"
                    >
                      <v-tooltip
                        color="#fff"
                        left
                        nudge-right="10"
                        nudge-top="35"
                      >
                        <template #activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="modal_plus_icon ml-3 primary--text"
                            style="font-size: 35px"
                            >+</span
                          >
                        </template>
                        <span>{{ $t("createSupplier") }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 py-1">
                <div class="row no-gutters py-1">
                  <div class="col-lg-5 pt-lg-2 pt-0 medium_15_01456A">
                    {{ $t("product") }}
                  </div>
                  <vue-select
                    ref="productSelect"
                    infinite
                    v-model="editedItem.productId"
                    :get-item-promise="
                      ({ text, page }) =>
                        $store.dispatch('getProducts', {
                          name: text,
                          page,
                          type_id: productFilter.type_id,
                          group_id: productFilter.group_id,
                          limit: 15,
                        })
                    "
                    :items="products"
                    :loading="productInputLoading"
                    :name="$t('product')"
                    class="product-select-in-modal col-lg-7"
                    rules="required"
                    @item-resolved="setProduct"
                    @next-page-resolved="
                      (data) => setProduct([...products, ...data])
                    "
                    @input="editedItem.unitTypeId = null"
                  >
                    <template #option="{ item }">
                      <v-list-item-title>
                        <p class="ma-0">{{ item.name }}</p>
                        <span class="v-messages">{{
                          item.attrs.join(" && ")
                        }}</span>
                      </v-list-item-title>
                    </template>
                  </vue-select>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 py-1">
                <div class="row no-gutters">
                  <div class="col-lg-5 pt-lg-3 pt-0 medium_15_01456A">
                    {{ $t("typeDelivery") }}
                  </div>
                  <custom-select
                    v-model="editedItem.supplyType"
                    :disabled="formState === 'add' || formState === 'edit'"
                    :item-text="(val) => $t(val.name)"
                    :items="deliveryTypes"
                    :name="$t('typeDelivery')"
                    :placeholder="$t('typeDelivery')"
                    class="col-lg-7 user_input no-margin"
                    item-value="value"
                    rules="required"
                  ></custom-select>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 py-1">
                <div class="row no-gutters">
                  <div class="col-lg-5 pt-lg-3 pt-0 medium_15_01456A">
                    {{ $t("unit") }}
                  </div>
                  <custom-select
                    v-model="editedItem.unitTypeId"
                    :item-text="`name_${$i18n.locale}`"
                    :items="unitTypes"
                    :name="$t('unit')"
                    class="col-lg-7 user_input no-margin"
                    rules="required"
                  ></custom-select>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 py-1">
                <div class="row no-gutters">
                  <div class="col-lg-5 pt-lg-5 medium_15_01456A">
                    {{ $t("dateOfConclusionContract") }}
                  </div>
                  <div class="col-lg-7">
                    <custom-date-picker
                      :disabled="formState === 'add' || formState === 'edit'"
                      v-model="editedItem.conclusionDate"
                      :max="new Date()"
                      :name="$t('enterDate')"
                      :placeholder="$t('dateOfConclusionContract')"
                      class="user_input no-margin"
                      rules="required"
                    ></custom-date-picker>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 py-0">
                <div class="row no-gutters">
                  <div class="col-lg-5 pt-lg-5 pt-0 medium_15_01456A">
                    <div class="d-flex align-center">
                      {{ $t("count") }}
                      <v-sheet
                        v-show="lastProduct.id"
                        color="primary"
                        dark
                        class="ml-2 pa-1 rounded"
                        >{{ lastProduct.count }} +
                      </v-sheet>
                    </div>
                  </div>
                  <custom-input-text
                    type="number"
                    v-model="editedItem.count"
                    :name="$t('count')"
                    :precision="2"
                    class="col-lg-7 user_input"
                    rules="required|max_value:1000000000"
                  ></custom-input-text>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 py-0">
                <div class="row no-gutters">
                  <div class="col-lg-5 pt-lg-5 pt-0 medium_15_01456A">
                    {{ $t("estimatedDeliveryDate") }}
                  </div>
                  <div class="col-lg-7">
                    <custom-date-picker
                      v-model="editedItem.guessReceiveDate"
                      :name="$t('estimatedDeliveryDate')"
                      :placeholder="$t('enterDate')"
                      class="user_input"
                      rules="required"
                    ></custom-date-picker>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="footer_modal_user">
            <div class="row align-center pt-4">
              <div class="col-xs-6 pt-0 ml-3 pb-0 file_input_modal_add_ozl">
                <validation-provider
                  v-if="!editedItem.fileLink"
                  v-slot="{ errors }"
                  :name="$t('file')"
                  :rules="{ required: editedItem, document: true }"
                >
                  <v-file-input
                    class="mt-6"
                    v-model="editedItem.file"
                    :error-messages="errors[0]"
                    :label="$t('attachFile') + '*'"
                  ></v-file-input>
                </validation-provider>
                <div v-else class="pt-2">
                  <div class="primary white--text rounded">
                    <v-btn
                      class="white-icon"
                      icon
                      @click="editedItem.fileLink = null"
                    >
                      <v-icon color="white" size="16">mdi-close</v-icon>
                    </v-btn>
                    {{ editedItem.fileName }}
                    <Downloader
                      btn-class="white-icon"
                      :address="editedItem.fileLink"
                      :file-name="editedItem.fileName"
                    />
                  </div>
                </div>
              </div>
              <div
                class="d-flex flex-wrap justify-space-around button_modal_add mr-3 mt-3"
              >
                <v-btn color="primary" dark type="submit">
                  {{
                    formState === "create"
                      ? $t("save")
                      : isFormEdit
                      ? $t("save")
                      : $t("add")
                  }}
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </form>
      </validation-observer>
    </v-card>
    <supplier-create-dialog
      v-model="supplierDialog"
      @onSaved="(data) => setSupplier([...suppliers, data])"
    ></supplier-create-dialog>
  </v-dialog>
</template>

<script>
import { addTimeZone, isISOSTime, isValidDate } from "@/utils/pureFunctions";
import moment from "moment";
import { deliveryTypes } from "@/utils/constants";
import Downloader from "@/components/ui/downloader";
import SupplierCreateDialog from "@/components/ozl/SupplierCreateDialog";
import VueSelect from "@/components/ui/vue-select/VueSelect";

const lastProduct = {
  id: null,
  count: null,
};

export default {
  name: "contract-form-dialog",
  props: {
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      productFilter: {
        type_id: null,
        group_id: null,
        pagination: false,
        name: null,
        limit: 50,
      },
      formState: "create",
      suppliers: [],
      products: [],
      productInputLoading: false,
      productTypes: [],
      lastProduct: { ...lastProduct },
      supplierDialog: false,
      editedItem: {
        code: null,
        productId: null,
        count: null,
        unitTypeId: null,
        departmentId: null,
        supplierId: null,
        supplyType: null,
        conclusionDate: null,
        guessReceiveDate: null,
        file: null,
        warehouseId: null,
      },
    };
  },
  methods: {
    setSupplier(suppliers) {
      this.suppliers = suppliers;
    },
    setProduct(products) {
      this.products = products;
    },
    setProductType(productTypes) {
      this.productTypes = productTypes;
    },
    clearForm() {
      const { contractFormObs } = this.$refs;
      const { productTypeSelect, productSelect } = this.$refs;

      this.editedItem = {
        code: null,
        productTypeId: null,
        productGroupId: null,
        productId: null,
        count: null,
        unitTypeId: null,
        departmentId: null,
        supplierId: null,
        supplyType: null,
        conclusionDate: null,
        guessReceiveDate: null,
        file: null,
        warehouseId: null,
      };

      this.products = [];

      if (contractFormObs) contractFormObs.reset();
      if (productTypeSelect) productTypeSelect.reset();
      if (productSelect) productSelect.resetComponent();
    },
    open(
      type,
      child,
      /**
       * @type Object
       * @property supplierName
       * @property productResourceLink
       * @property productResourceName
       */
      parent
    ) {
      if (type === "create") {
        this.formState = "create";
        this.productFilter.type_id = null;
      } else if (type === "edit") {
        this.suppliers = [{ name: parent.supplierName, id: parent.supplierId }];
        if (child.productTypeId) {
          this.productFilter.type_id = child.productTypeId;
          this.productTypes = [
            { id: child.productTypeId, name: child.productTypeName },
          ];
        }
        this.editedItem = {
          ...this.editedItem,
          ...parent,
          ...child,
          id: null,
          parentId: parent.id,
          unitTypeId: (child.unitTypeId && child.unitTypeId) || null,
          contractId: null,
          contractItemId: child.id,
          productId: child.productId,
          productTypeId: child.productTypeId,
          guessReceiveDate: addTimeZone(
            addTimeZone(child.itemGuessReceiveDate)
          ).toISOStringWithTimeZone(),
          conclusionDate: parent.conclusionDate
            ? addTimeZone(
                addTimeZone(parent.conclusionDate)
              ).toISOStringWithTimeZone()
            : null,
          fileLink: parent.productResourceLink,
          fileName: parent.productResourceName,
        };
        this.formState = "edit";
        this.productFilter.name = child.productName;
        this.getProducts(child.productId);
      } else if (type === "add") {
        this.suppliers = [{ name: parent.supplierName, id: parent.supplierId }];
        this.editedItem = {
          ...this.editedItem,
          ...parent,
          guessReceiveDate:
            parent.guessReceiveDate && addTimeZone(parent.guessReceiveDate),
          fileLink: parent.productResourceLink,
          fileName: parent.productResourceName,
        };
        this.formState = "add";
      }
      this.$emit("input", true);
    },
    async getProducts(productId) {
      try {
        this.productInputLoading = true;
        const { data } = await this.$store.dispatch("getProducts", {
          productId,
        });
        this.products = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.productInputLoading = false;
      }
    },
    close() {
      this.$emit("input", false);
    },
    async save() {
      this.showLoading();
      const formData = new FormData();
      let {
        id,
        code,
        contractId,
        supplierId,
        departmentId,
        productId,
        conclusionDate,
        count,
        file,
        guessReceiveDate,
        supplyType,
        unitTypeId,
        warehouseId,
        contractItemId,
      } = this.editedItem;
      if (code) formData.append("code", code);
      if (contractId) formData.append("contractId", contractId);
      if (warehouseId) formData.append("warehouseId", warehouseId);
      if (file) formData.append("file", file);
      if (id) formData.append("id", id);
      if (departmentId) formData.append("departmentId", departmentId);
      if (contractItemId) formData.append("contractItemId", contractItemId);
      count = count.replace(",", ".").replace(/\s/g, "");
      formData.append("count", count);
      formData.append("supplierId", supplierId);
      formData.append("productId", productId);
      if (conclusionDate && isValidDate(conclusionDate))
        if (!isISOSTime(conclusionDate)) {
          conclusionDate = new Date(conclusionDate).toISOStringWithTimeZone();
        }
      formData.append("conclusionDate", conclusionDate);
      if (guessReceiveDate && isValidDate(guessReceiveDate)) {
        if (!isISOSTime(guessReceiveDate)) {
          guessReceiveDate = new Date(
            guessReceiveDate
          ).toISOStringWithTimeZone();
        }
        formData.append("guessReceiveDate", guessReceiveDate);
      }
      formData.append("supplyType", supplyType);
      formData.append("unitTypeId", unitTypeId);

      try {
        if (this.lastProduct.id) {
          formData.delete("id");
          formData.append("parentId", this.editedItem.id);
          await this.saveItemContract(formData);
        } else if (this.formState === "edit") {
          formData.append("parentId", this.editedItem.parentId);
          formData.append("id", this.editedItem.contractItemId);
          formData.delete("contractItemId");
          await this.saveItemContract(formData);
        } else {
          await this.saveContract(formData);
        }
        this.close();
        this.$emit("update-contracts");
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    reset() {
      const { contractFormObs } = this.$refs;
      if (contractFormObs) contractFormObs.reset();
    },
    handleProductTypeChange() {
      this.editedItem.productId = null;
      this.editedItem.unitTypeId = null;

      this.products = [];

      if (this.$refs.productSelect) {
        this.$refs.productSelect.resetComponent();
      }

      this.$emit("get-products");
    },
    async saveContract(formData) {
      return this.$http.post("contract/save-ozl", formData);
    },
    async saveItemContract(formData) {
      return this.$http.post("contract/save-item/ozl", formData);
    },
    async checkAddedProduct({ contractId, productId, unitTypeId }) {
      if (contractId && productId && unitTypeId) {
        const {
          data: { data },
        } = await this.$http.get("contract/get-single", {
          params: {
            contractId,
            productId,
            unitTypeId,
          },
        });
        if (data) {
          this.lastProduct = {
            count: data.count,
            id: data.id,
          };
        } else {
          this.lastProduct = { ...lastProduct };
        }
      } else {
        this.lastProduct = { ...lastProduct };
      }
    },
  },
  computed: {
    moment: () => moment,
    formTitle() {
      const { formState } = this;
      if (formState === "create") {
        return this.$t("createContract");
      }
      if (formState === "add") {
        return `${this.$t("addToContract")} ${
          this.editedItem.code && "№ " + this.editedItem.code
        } `;
      }
      if (this.isFormEdit) {
        return `${this.$t("editGroup")}`;
      }
      return "";
    },
    unitTypes() {
      if (this.editedItem.productId) {
        const product = this.products.find(
          (i) => i.id === this.editedItem.productId
        );
        if (product) {
          return product.unitTypes;
        }
      }
      return [];
    },
    deliveryTypes: () => deliveryTypes,
    isFormEdit() {
      return this.formState === "edit";
    },
  },
  watch: {
    value(val) {
      this.lastProduct = { ...lastProduct };
      if (!val) {
        this.clearForm();
      }
    },
    "editedItem.productId"(productId) {
      const contractId = this.editedItem.contractId || this.editedItem.id;
      this.checkAddedProduct({
        contractId,
        unitTypeId: this.editedItem.unitTypeId,
        productId,
      });
    },
    "editedItem.unitTypeId"(unitTypeId) {
      const contractId = this.editedItem.contractId || this.editedItem.id;
      this.checkAddedProduct({
        contractId,
        unitTypeId,
        productId: this.editedItem.productId,
      });
    },
  },
  components: {
    VueSelect,
    // ProductSelectItem,
    // searchInput,
    Downloader,
    // NumberInput,
    SupplierCreateDialog,
  },
};
</script>
